export default __webpack_public_path__ + "static/media/how-you-like-that.68125282.jpg";